import { useSelector } from 'react-redux'
import { getOrganization } from 'data/organizations/selectors'

export default function useOrganizationField(fieldName: string) {
  return useSelector(state => getOrganization(state)[fieldName])
}
